import type { FC } from 'react'
import { Image, type ImagePropTypes } from 'react-datocms'

type ImageWithAmpProps = Pick<ImagePropTypes, 'data' | 'className' | 'layout' | 'objectFit' | 'objectPosition'>

export const DatoImage: FC<ImageWithAmpProps> = ({ data, className, layout, objectFit, objectPosition }) => (
  <Image data={data} className={className} layout={layout} objectFit={objectFit} objectPosition={objectPosition} />
)
